<template>
    <div>
        
        
        <div v-if="showPageList" v-bind:key="'showpage'" class="float-pagination">                
            <a @click="goSelectedSoal(nomor)" v-for="nomor in tallySoal" v-bind:key="nomor" :class="[(soalke == nomor) ? 'active':'', (soalSudahJawab[nomor] ? 'finished':'')]" :title="'Soal ke ' +nomor" href="#">{{ nomor }}</a>                            
            <a href="#" @click="showPageList = !showPageList" v-bind:key="'lastpage'" class="hide-pagination">Tutup &raquo;</a>                
        </div>
        <div v-if="!showPageList" v-bind:key="'hidePage'">                        
            <a href="#" @click="showPageList = !showPageList" v-bind:key="'hidePageLink'" class="show-page-list-btn">
                &nbsp;&nbsp;&laquo; Daftar Soal &nbsp;
            </a>
        </div>
                    
        
        <div class="container-fluid">
            <div class="page-title">
              <div class="row">
                <div class="col-6 d-flex">
                  <h3>Tes : {{titleTes}}</h3>
                </div>
                <div class="col-6">
                  
                </div>
              </div>
            </div>
        </div>
    
        
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="box box-success box-solid">
                            <div class="box-header with-border">
                                <div class="box-tools pull-right">
                                    <div class="pull-right">
                                        <div id="sisa-waktu">Sisa Waktu : {{ time }} menit</div>
                                    </div>
                                </div>
                                <div class>
                                    <h3 class="box-title">Soal <span id="judul-soal">ke {{ soalke }}</span></h3>
                                </div>
                            </div><!-- /.box-header -->
                            <div class="box-body">
                                <div id="isi-tes-soal" style="font-size: 15px;">
                                    <p><span v-html="currentSoal"></span></p>
                                    <hr>                                    
                                    <div v-if="currentSoalType==='ESSAY_UPLOAD'">
                                        <div class="soaal-image" v-if="currentPictType === 'pdf'">                                                                            
                                            <b-button @click="openPdf()" type="button" variant="primary" class="mr-1" title="Lihat Soal">Lihat Soal</b-button>
                                        </div>
                                        <div v-else class="soaal-image">
                                            <b-img :src="currentPictUrl" fluid alt=""></b-img>           
                                        </div>
                                        <hr>
                                    </div>
                                    <div v-if="currentSoalType==='ESSAY'">                                        
                                        <!--
                                        <div v-if="currentPict!==''" class="soaal-image">
                                            <b-img :src="currentPictUrl" fluid alt=""></b-img>           
                                            <hr>
                                        </div>
                                        -->
                                    </div>
                                    
                                    <div class="form-group">                                        
                                        <div v-if="currentSoalType==='ESSAY_UPLOAD'">
                                            <div v-if="isShowPdfDownloadField">
                                                <p>Upload Jawaban PDF di sini:</p>
                                                <b-form @submit="uploadFile">                                                
                                                    <input type="file" id="file" ref="file"  @change="changeFile" :accept="accepts">
                                                    <hr>
                                                                                                    
                                                    <b-button type="submit" variant="primary" class="mr-1" title="Simpan Jawaban">Simpan File</b-button>
                                                </b-form>
                                                <hr>
                                                <!-- <object :data="objectURL" :type="type"/> -->
                                                <iframe :src="objectURL"></iframe>
                                                <hr>
                                                <br>
                                            </div>
                                            
                                            <div v-if="isShowImageDownloadField">
                                                <p>Upload Jawaban gambar jpg di sini:</p>
                                                <vue-dropzone 
                                                        id="singledropzone" 
                                                        :options="singledropzoneOptions"
                                                        v-on:vdropzone-success="uploadSuccess"                                             
                                                        class="dropzone digits">
                                                </vue-dropzone>
                                                <br>
                                            </div>
                                            
                                            
                                            <div v-if="isShowJawabanKeDua">                                                                                            
                                                <hr>
                                                <p>Upload Jawaban di sini:</p>
                                                <vue-dropzone 
                                                        id="singledropzone2" 
                                                        :options="singledropzoneOptions2"
                                                        v-on:vdropzone-success="uploadSuccess2"                                             
                                                        class="dropzone digits">
                                                </vue-dropzone>
                                                <br>
                                            </div>
                                            
                                            <div v-if="isShowJawabanKeTiga">                                                
                                                <hr>
                                                <p>Upload Jawaban di sini:</p>
                                                <vue-dropzone 
                                                        id="singledropzone3" 
                                                        :options="singledropzoneOptions3"
                                                        v-on:vdropzone-success="uploadSuccess3"                                             
                                                        class="dropzone digits">
                                                </vue-dropzone>
                                                <br>
                                            </div>
                                            
                                            <div v-if="isShowJawabanKeEmpat">                                                
                                                <hr>
                                                <p>Upload Jawaban di sini:</p>
                                                <vue-dropzone 
                                                        id="singledropzone4" 
                                                        :options="singledropzoneOptions4"
                                                        v-on:vdropzone-success="uploadSuccess4"                                             
                                                        class="dropzone digits">
                                                </vue-dropzone>
                                                <br>
                                            </div>
                                            <b-button v-if="!isShowJawabanKeEmpat && isShowImageDownloadField" @click="jawab2()" type="button" variant="success" class="mr-1" title="Tambah Jawaban">Tambah Jawaban</b-button>
                                            <br>
                                            <br>
                                            <hr>
                                        </div>
                                        <div v-else-if="currentSoalType==='ESSAY'">
                                            <div v-if="isShowEssayTextAnswer" class="col">
                                            <textarea class="textarea" id="soal-jawaban" v-model="jawaban_essay" style="width: 100%; height: 150px; font-size: 13px; line-height: 25px; border: 1px solid #dddddd; padding: 10px;"></textarea>
                                            <br>
                                            </div>
                                            <div v-if="isShowEssayUploadAnswer" class="col">
                                                <div v-show="!sudahUploadPicurl1" class="col">
                                                    <p>Upload Jawaban gambar jpg di sini:</p>
                                                    <vue-dropzone
                                                            ref="myVueDropzone" 
                                                            id="singledropzone" 
                                                            :options="singledropzoneOptions"
                                                            v-on:vdropzone-success="uploadSuccess"                                             
                                                            class="dropzone digits">
                                                    </vue-dropzone>
                                                    <br>
                                                </div>
                                                <div v-show="sudahUploadPicurl1" class="col-md-6">                                                    
                                                    <b-img thumbnail fluid :src="baseUrlPict + form_data.picurl + '?t=' + soalke + '-' + uniqueImageIdentifier1" alt=""></b-img>
                                                </div>
                                                <hr>
                                                <div v-show="!sudahUploadPicurl2" class="col">
                                                    <p>Upload Jawaban tambahan di sini:</p>
                                                    <vue-dropzone 
                                                            ref="myVueDropzone2"
                                                            id="singledropzone2" 
                                                            :options="singledropzoneOptions2"
                                                            v-on:vdropzone-success="uploadSuccess2"                                             
                                                            class="dropzone digits">
                                                    </vue-dropzone>
                                                    <br>
                                                </div>
                                                <div v-show="sudahUploadPicurl2" class="col-md-6">                                                    
                                                    <b-img thumbnail fluid :src="baseUrlPict + form_data.picurl2" alt=""></b-img>
                                                </div>
                                                <hr>
                                                <div v-show="!sudahUploadPicurl3" class="col">
                                                    <p>Upload Jawaban tambahan di sini:</p>
                                                    <vue-dropzone 
                                                            ref="myVueDropzone3"
                                                            id="singledropzone3" 
                                                            :options="singledropzoneOptions3"
                                                            v-on:vdropzone-success="uploadSuccess3"                                             
                                                            class="dropzone digits">
                                                    </vue-dropzone>
                                                    <br>
                                                </div>
                                                <div v-show="sudahUploadPicurl3" class="col-md-6">                                                    
                                                    <b-img thumbnail fluid :src="baseUrlPict + form_data.picurl3" alt=""></b-img>
                                                </div>
                                                <hr>
                                                <div v-show="!sudahUploadPicurl4" class="col">
                                                    <p>Upload Jawaban tambahan di sini:</p>
                                                    <vue-dropzone 
                                                            ref="myVueDropzone4"
                                                            id="singledropzone4" 
                                                            :options="singledropzoneOptions4"
                                                            v-on:vdropzone-success="uploadSuccess4"                                             
                                                            class="dropzone digits">
                                                    </vue-dropzone>
                                                    <br>
                                                </div>
                                                <div v-show="sudahUploadPicurl4" class="col-md-6">                                                    
                                                    <b-img thumbnail fluid :src="baseUrlPict + form_data.picurl4" alt=""></b-img>
                                                </div>
                                            </div>
                                        </div>  
                                        <div v-else>
                                            <div class="form-group">
                                                <div v-for="(row, index) in currentSoalJawabanPg" :key="row.id" style="display:flex; justify-content:flex-start; align-items:center;" class="mb-2">
                                                    <div class="align-top">
                                                        <input type="radio" @change="onChangePg($event)" name="soal-jawaban" v-model="currentJawabanPg" :value="row.id">
                                                    </div>
                                                    <div>
                                                        &nbsp;&nbsp;{{ getCharNumber(index) }}
                                                    </div>
                                                    <div class="col-auto">
                                                        <span v-html="row.jawaban_detail"></span>
                                                    </div>
                                                </div>
                                                                                                
                                            </div>
                                        </div>                                       
                                        
                                        <div v-if="currentSoalType === 'ESSAY_UPLOAD'">
                                            <b-button @click="showNotifJawab()" type="button" variant="primary" class="mr-1" title="Simpan Jawaban">Simpan Jawaban</b-button>
                                        </div>
                                        <div v-if="currentSoalType === 'ESSAY'">
                                            <b-button @click="jawabEssay()" type="button" variant="primary" class="mr-1" title="Simpan Jawaban">Simpan Jawaban</b-button>
                                        </div>
                                    </div>                    
                                </div>
                            </div><!-- /.box-body -->
                            <div class="box-footer" v-if="currentSoalType!=='ESSAY_UPLOAD'">
                                <div style="text-align:center;">                                
                                <feather @click="goPrevSoal()" v-if="soalke > 1" style="cursor:pointer;" type="arrow-left" stroke="red"></feather> &nbsp;&nbsp;&nbsp;
                                <feather @click="goNextSoal()" v-if="soalke < totalSoal" style="cursor:pointer;" type="arrow-right" stroke="red"></feather>
                                </div>
                                
                            </div>
                        </div>
                    </div>                
                </div>
              </div>
            </div>
            
            
            <div class="row" v-if="currentSoalType!=='ESSAY_UPLOAD'">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div v-if="showDaftarSoal" class="box box-success box-solid">
                                <div class="box-header with-border">
                                    <!--<h3 class="box-title">Daftar Soal</h3>-->
                                </div><!-- /.box-header -->
                                <div class="box-body">
                                    <!--
                                    <ul class="pagination">                                                                                
                                        <li v-for="nomor in tallySoal" v-bind:key="nomor" :class="[(soalke == nomor) ? 'active selected':'', (soalSudahJawab[nomor] ? 'active finished':'')]"  class="page-item" :title="'Soal ke ' +nomor">
                                            <a href="javascript:void(0)" @click="goSelectedSoal(nomor)" class="page-link">{{ nomor }}</a>
                                        </li>
                                                                                
                                    </ul>
                                    <p class="help-block">Soal yang sudah dijawab akan berwarna Biru.</p>
                                    -->
                                </div><!-- /.box-body -->
                                <div class="box-footer">
                                    <b-button @click="akhiriTes()" class="btn btn-default pull-right" id="btn-hentikan">Hentikan Tes</b-button>
                                </div>
                            </div><!-- /.box -->
                            <div v-else class="box box-success box-solid">
                                <div class="box-header with-border">
                                    
                                </div><!-- /.box-header -->
                                <div class="box-body">
                                    
                                </div><!-- /.box-body -->
                                <div class="box-footer">
                                    <b-button @click="akhiriTes()" class="btn btn-default pull-right" id="btn-hentikan">Hentikan Tes</b-button>
                                </div>
                            </div><!-- /.box -->
                        </div>
                    </div>
                </div>                
            </div>
        
            
        </div>
        <!-- Container-fluid Ends-->
        <div class="loader" v-if="loader"></div>
    </div>
</template>

<script>
    import {url} from "@/urls";
    import {service} from '@/services';
    import {helper} from '@/services/helper';
    import * as _ from 'underscore';
    import moment from 'moment';
    import vue2Dropzone from 'vue2-dropzone';
    import pdf from 'pdfvuer';
    import axios from 'axios';

    export default {
        data(){
            return{
                currentIdTopik: 0,
                showPageList: false,
                uniqueImageIdentifier1: "123",
                uniqueImageIdentifier2: "234",
                uniqueImageIdentifier3: "345",
                uniqueImageIdentifier4: "456", 
                canSavePdf: false,
                isShowEssayTextAnswer: false,
                isShowEssayUploadAnswer: true,
                isShowPdfDownloadField: true,
                isShowImageDownloadField: true,
                name: "",
                type: "",
                size: 0,
                lastModified: null,
                lastModifiedDate: null,
                objectURL: null,
                accepts: ["application/pdf"].join(","),
                loader:false,
                currentJawabanPg: null,
                jawaban_essay: "",
                soalSudahJawab: [],
                showDaftarSoal: true,
                showJawabanKeDua: false,
                showJawabanKeTiga: false,
                showJawabanKeEmpat: false,
                totalTime: (25 * 60),
                timerRunning: false,               
                interval: null,
                baseUrlPict: "",
                currentPict: "",
                currentPictUrl: "",
                currentPictType: "",
                currentSoal: "",
                currentIdSoal: 0,
                currentSoalType: "",
                currentSoalJawabanPg: [],
                allSoal: [],
                tallySoal: [],
                totalSoal: 0,
                currentIdTest: null,
                titleTes: "",
                soalke: 1,
                sisaWaktu: 0,                
                singledropzoneOptions:{},                    
                singledropzoneOptions2: {},
                singledropzoneOptions3: {},
                singledropzoneOptions4: {},
                form_data:{
                    idtenant: localStorage.getItem("idtenant"),                    
                    picurl: "",
                    picurl2: "",
                    picurl3: "",
                    picurl4: ""
                },
                timeoutProcess: false
            }
        },
        methods: {
            getCharNumber(idx) {
                let alfa = ['A','B','C','D','E','F'];
                return alfa[idx];
            },
            changeFile(event) {
                if (this.objectURL) {
                    URL.revokeObjectURL(this.objectURL);
                }

                this.isShowImageDownloadField = false;

                const file = event.target.files[0];

                if (file.size >= 8000000) {
                    this.canSavePdf = false;
                    this.objectURL = "";
                    this.$toasted.show(" Ukuran File terlalu besar, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                } else {
                    this.name = file.name;
                    this.type = file.type;
                    this.size = file.size;
                    this.lastModifiedDate = file.lastModifiedDate;
                    this.lastModified = file.lastModified;
                    this.objectURL = URL.createObjectURL(file);
                    this.canSavePdf = true;
                }                
            },
            uploadFile: function(evt){                
                evt.preventDefault();
                if (this.canSavePdf) {
                    this.loader = true;
                    const file = this.$refs.file.files[0];

                    let formData = new FormData();
                    formData.append('file', file);

                    axios.post(process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-1", formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.loader = false;                    
                        if(!response.data){
                            //alert('File not uploaded.');
                            this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        }else{
                            //alert('File uploaded successfully.');                        
                            console.log('File Successfully Uploaded with file name: ' + response.data);
                            this.$toasted.show(" File berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 5000});
                            this.form_data.picurl = response.data;                        
                        }

                    })
                    .catch(error => {
                        this.loader = false;
                        this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        console.log(error);
                    });
                } else {
                    this.$toasted.show(" Jawaban harus diupload dahulu ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                }                                
            },
            changeJawabanPg(idJawab) {
                //this.loader = true;
                    
                let body = { 
                    selected: 1                          
                }
                service.onUpdate(url.cbt_test_jawaban + "/" + idJawab, body)
                    .then(result => {
                        this.getAllSoal();
                        console.log('save status test', result);
                        this.$toasted.show(" Jawaban berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 5000});
                        setTimeout(() => {                            
                            this.loader = false;
                        }, 1000);
                                            
                    }).catch(error => {
                        setTimeout(() => {
                            // eslint-disable-next-line
                            console.log(error);
                            this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                            this.loader = false;
                        }, 1000);                        
                    })
            },
            onChangePg(event) {
                //bypass
                alert('yuks')
            },
            _onChangePg(event) {
              var idJawab = event.target.value;
              console.log(idJawab);

              this.loader = true;
                    
                let body = { 
                    selected: 0                          
                }
              service.onUpdate(url.cbt_test_jawaban_reset + "/" + this.currentIdSoal, body)
                    .then(result => {
                        
                        console.log('save status test', result);
                        
                        this.changeJawabanPg(idJawab);
                                            
                    }).catch(error => {
                        setTimeout(() => {
                            // eslint-disable-next-line
                            console.log(error);
                            this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                            this.loader = false;
                        }, 1000);                        
                    })
            },
            akhiriTes() {
                this.$swal({
                    icon: 'warning',
                    title: `Apakah kamu yakin mengakhiri tes ?`,
                    text : `Pastikan jawaban sudah terisi semua`,
                    showCancelButton: true,
                    cancelButtonText: `Tidak`,
                    confirmButtonText: `Ya`,
                }).then((res) => {
                    if (res.isConfirmed) {
                        // bypass
                        //this.updateStatusTest();
                    }
                })                
            }, 
            showNotifJawab() {
                this.$swal({
                    icon: 'warning',
                    title: `Apakah kamu yakin simpan jawaban ?`,
                    text : `Pastikan jawaban sudah terupload`,
                    showCancelButton: true,
                    cancelButtonText: `Tidak`,
                    confirmButtonText: `Ya`,
                }).then((res) => {
                    if (res.isConfirmed) {
                        this.jawab();
                    }
                })
            },
            openPdf: function () {
                window.open(this.currentPictUrl, '_blank');
                // TODO: use a pdf library to show pdf   
                //let pictData = helper.strEncode(this.currentPict)
                //let routeData = this.$router.resolve({name: 'ShowPdf', query: {data: pictData}});
                //window.open(routeData.href, '_blank');
            },
            timerRun() {
                this.timerRunning = true;                
                this.interval = setInterval(this.countdownTimer, 1000);                
            },
            timerCountdown() {
                console.log('Working');
                this.timerRunning = true;
                this.interval = setInterval(this.updateCurrentTime, 1000);
                // Counts down from 60 seconds times 1000.
                setInterval( () => {
                    this.timerMinutes--
                }, 60 * 1000)
                
                // Check if seconds at double zero and then make it a 59 to countdown from.
                // need another method of checking the number while in the loop and then adding a zero on the number under 10
                // if(this.timerSeconds === '00'){
                //     this.timerSeconds = 59;
                //     setInterval( () => {
                //     this.timerSeconds--
                //     }, 1000);
                // } else {
                //     setInterval( () => {
                //     this.timerSeconds--
                //     }, 1000);
                // }
            },
            countdownTimer() {
                if (this.timerRunning == true) {
                    this.totalTime--;
                    
                    if (this.totalTime < 0 && this.timeoutProcess == false) {
                        this.timeoutProcess = true;
                        this.getTestDetail();                                                                                                   
                    }
                }
            },
            updateStatusTest() {
                this.loader = true;
                    
                let body = { 
                    status: 'f'                         
                }
                console.log(body);
                
                service.onUpdate(url.cbt_test_siswa + "/" + this.$route.params.idtest, body)
                    .then(result => {
                        
                        console.log('save status test', result);
                        this.$toasted.show(" Jawaban berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 5000});
                        setTimeout(() => {
                            this.$router.push({name:'DashboardSiswa'});
                            this.loader = false;
                        }, 1000);
                                            
                    }).catch(error => {
                        setTimeout(() => {
                            // eslint-disable-next-line
                            console.log(error);
                            this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                            this.loader = false;
                        }, 1000);                        
                    })
            },
            jawabEssay() {
                //bypass
                alert('hehe')
            },
            __jawabEssay() {
                console.log('JAWAB ESSAY', this.jawaban_essay, this.form_data)
                if (this.form_data.picurl != "" || this.jawaban_essay) {
                    let createdDate = moment();
                    var jwbEssay = ""
                    if (this.isShowEssayUploadAnswer) {
                        var jawabanPict = {
                            "jawaban1": this.form_data.picurl,
                            "jawaban2": this.form_data.picurl2,
                            "jawaban3": this.form_data.picurl3,
                            "jawaban4": this.form_data.picurl4 
                        }
                        jwbEssay = JSON.stringify(jawabanPict)                                            
                    } else {
                        jwbEssay = this.jawaban_essay
                    }
                    let body = { 
                        jawaban: jwbEssay,
                        nilai: 0,
                        idsiswa: this.userDetail.iduser,                        
                        display_time: createdDate                                           
                    }
                    console.log(body);
                    
                    service.onUpdate(url.cbt_test_soal + "/" + this.currentIdSoal, body)
                        .then(result => {                             
                            console.log("JAWABAN ERROR", this.allSoal[this.soalke-1])      
                            this.allSoal[this.soalke-1].jawaban = jwbEssay;
                            this.buildSoalSudahJawab();                     
                            this.$toasted.show(" Jawaban berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 5000});                                                
                        }).catch(error => {
                            setTimeout(() => {
                                // eslint-disable-next-line
                                console.log(error);
                                this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                                this.loader = false;
                            }, 1000);
                            
                        })
                } else {
                    this.$toasted.show(" Silahkan isi jawaban terlebih dahulu ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                }                
            },
            jawab2() {                
                if (this.form_data.picurl != "") {
                    if (!this.isShowJawabanKeDua) {                    
                        this.showJawabanKeDua = true;
                    } else if (!this.isShowJawabanKeTiga) {
                        this.showJawabanKeTiga = true;
                    } else if (!this.isShowJawabanKeEmpat) {
                        this.showJawabanKeEmpat = true;
                    }
                } else {
                    this.$toasted.show(" Jawaban harus diupload dahulu ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                }
            },            
            jawab() {
                /*
                1. update jawaban
                2. update status tes
                3. hapus localstorage
                4. go to dashboard
                */
                if (this.form_data.picurl != "") {
                    this.loader = true;
                    let createdDate = moment();                
                    var jawabanPict = {
                        "jawaban1": this.form_data.picurl,
                        "jawaban2": this.form_data.picurl2,
                        "jawaban3": this.form_data.picurl3,
                        "jawaban4": this.form_data.picurl4 
                    }
                    let body = { 
                        jawaban: JSON.stringify(jawabanPict),
                        nilai: 0,
                        idsiswa: this.userDetail.iduser,                        
                        display_time: createdDate                                           
                    }
                    console.log(body);
                    
                    service.onUpdate(url.cbt_test_soal + "/" + this.currentIdSoal, body)
                        .then(result => {
                            
                            console.log('save jawaban test', result);
                            this.updateStatusTest();
                                                
                        }).catch(error => {
                            setTimeout(() => {
                                // eslint-disable-next-line
                                console.log(error);
                                this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                                this.loader = false;
                            }, 1000);
                            this.cancelAdd()
                        })
                } else {
                    this.$toasted.show(" Jawaban harus diupload dahulu ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                }
            },        
            getTestDetail() {               
                this.loader = true;
                
                service.onGet(`${url.cbt_test}/${this.$route.params.idtest}`)                
                .then((result) => {
                    console.log("BLAH XYXYX-> ",result.data)
                    this.loader = false;
                    if (result.data) {
                        this.currentIdTest = result.data.id
                        this.titleTes = result.data.title
                        this.sisaWaktu = result.data.durasi                        
                        this.totalTime = this.sisaWaktu * 60;                                                
                        this.timeoutProcess = false;
                        this.currentIdTopik = result.data.idtopik
                        if (this.timerRunning == false) {
                            this.timerRun();
                        }
                                                        
                        // get soal
                        this.getAllSoal()                        
                    }
                      
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })
            },
            goSelectedSoal(nomor) {
                this.soalke = nomor;
                var curIdx = this.soalke;                                
                this.buildCurrentSoal();
                if (this.currentSoalType === "ESSAY") {
                    this.resetDropzoneOptions();
                }
                this.scrollToTop();                                
            },
            goNextSoal() {
                var curIdx = this.soalke + 1;                
                
                if (curIdx <= this.allSoal.length) {
                    this.soalke++;                    
                    this.buildCurrentSoal();
                    if (this.currentSoalType === "ESSAY") {
                        console.log('tik next soal')
                        this.resetDropzoneOptions();
                    }
                    this.scrollToTop();
                }                
            },
            goPrevSoal() {                
                var curIdx = this.soalke - 1;                
                
                if (curIdx > 0) {
                    this.soalke--;
                    this.buildCurrentSoal();
                    if (this.currentSoalType === "ESSAY") {
                        this.resetDropzoneOptions();
                    }
                    this.scrollToTop();
                }                
            },            
            buildSoalSudahJawab() {
                this.soalSudahJawab = [];
                var x = 0;
                for (x=0;x<this.allSoal.length;x++) {
                    this.soalSudahJawab[x+1] = false;
                    if (this.allSoal[x].Soal.tipe === "ESSAY") {
                        this.soalSudahJawab[x+1] = this.allSoal[x].jawaban !== null ? true : false;    
                    } else if (this.allSoal[x].Soal.tipe === "PG") {                        
                        if (this.allSoal[x].JawabanTest.length > 0) {
                            var i=0;
                            for (i=0;i<this.allSoal[x].JawabanTest.length;i++) {                            
                                if (this.allSoal[x].JawabanTest[i].selected === 1) {
                                    this.soalSudahJawab[x+1] = true;
                                }
                            }
                        }
                    }
                    
                }
                console.log("JWABA SUDAH", this.soalSudahJawab);
            },
            buildCurrentSoal() {                
                let idx = this.soalke - 1;
                
                this.loader = false;
                this.currentIdSoal = this.allSoal[idx].id;
                this.currentSoal = this.allSoal[idx].soal;
                this.currentPict = this.allSoal[idx].picurl;
                this.currentPictUrl = this.baseUrlPict + this.currentPict;
                this.currentPictType = this.currentPictUrl.split('.').pop().toLowerCase();
                this.jawaban_essay = this.allSoal[idx].jawaban;
                this.currentSoalType = this.allSoal[idx].tipe;
                this.currentSoalJawabanPg = this.allSoal[idx].Jawaban;
                console.log("JWB ESSAY UPLOAD", this.jawaban_essay);
                console.log("JWB PG", this.currentSoalJawabanPg);
                if (this.isShowEssayUploadAnswer) {
                    if (this.jawaban_essay) {
                        let parseJawaban = JSON.parse(this.jawaban_essay); 
                        this.form_data.picurl = parseJawaban.jawaban1;
                        this.form_data.picurl2 = parseJawaban.jawaban2;
                        this.form_data.picurl3 = parseJawaban.jawaban3;
                        this.form_data.picurl4 = parseJawaban.jawaban4;
                    } else {
                        this.form_data.picurl = "";
                        this.form_data.picurl2 = "";
                        this.form_data.picurl3 = "";
                        this.form_data.picurl4 = "";
                    }
                }
                console.log("PIC ", this.currentPictUrl, this.currentPictType, this.currentSoalJawabanPg)

                console.log('alljawab', this.allSoal[idx])
                // let currentJawab = this.allSoal[idx].JawabanTest;
                // console.log(currentJawab, "c")
                // if (currentJawab.length > 0) {
                //     var i=0;
                //     for (i=0;i<currentJawab.length;i++) {
                //         console.log("currentJawab", currentJawab[i].id, currentJawab[i].selected)
                //         if (currentJawab[i].selected === 1) {
                //             this.currentJawabanPg = currentJawab[i].id
                //         }
                //     }
                // }
            },
            getAllSoal() {
                this.loader = true;
                                
                service.onGet(`${url.soal_get_by_topik}/${this.currentIdTopik}`)
                .then((result) => {
                    console.log("BLAHXX ",result.data)                    
                    this.loader = false;
                    if (result.data) {
                        // jika soal kosong delete cbt test siswa, balik dari awal
                        if (result.data.length > 0) {
                            // shuffle jawaban PG
                            var x = 0;                            
                            for (x=0; x<result.data.length;x++) {                                
                                if (result.data[x].tipe === 'PG') {                                    
                                    result.data[x].Jawaban = _.shuffle(result.data[x].Jawaban);
                                }                                
                            }
                            
                            this.tallySoal = [];                            
                            this.allSoal = result.data;
                            this.totalSoal = this.allSoal.length;
                            var c = 0;
                            
                            //for navigation soal
                            for (c=0;c<result.data.length;c++) {
                                this.tallySoal.push(c+1);
                            }

                            //this.buildSoalSudahJawab();

                            this.buildCurrentSoal();
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: `Data soal belum ada!`,
                                text : `Silahkan ulangi kembali.`,
                                showCancelButton: false,                                        
                                confirmButtonText: `Ya`,
                            })
                        }
                        
                    }
                      
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })
            },

            uploadSuccess(file, response) {
                console.log('File Successfully Uploaded with file name: ' + response);
                this.isShowPdfDownloadField = false;
                this.form_data.picurl = response;
                this.uniqueImageIdentifier1 = moment().unix();
            },
            uploadSuccess2(file, response) {
                console.log('File Successfully Uploaded with file name: ' + response);
                this.form_data.picurl2 = response;
                this.uniqueImageIdentifier2 = moment().unix();
            },
            uploadSuccess3(file, response) {
                console.log('File Successfully Uploaded with file name: ' + response);
                this.form_data.picurl3 = response;
                this.uniqueImageIdentifier3 = moment().unix();
            },
            uploadSuccess4(file, response) {
                console.log('File Successfully Uploaded with file name: ' + response);
                this.form_data.picurl4 = response;
                this.uniqueImageIdentifier4 = moment().unix();
            },
            resetDropzoneOptions() {
                if (this.$refs.myVueDropzone) {                    
                    this.$refs.myVueDropzone.removeAllFiles()
                    this.$refs.myVueDropzone.setOption('url', process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-1")
                }

                if (this.$refs.myVueDropzone2) {
                    this.$refs.myVueDropzone2.removeAllFiles()
                    this.$refs.myVueDropzone2.setOption('url', process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-2")
                }

                if (this.$refs.myVueDropzone3) {
                    this.$refs.myVueDropzone3.removeAllFiles()
                    this.$refs.myVueDropzone3.setOption('url', process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-3")
                }

                if (this.$refs.myVueDropzone4) {
                    this.$refs.myVueDropzone4.removeAllFiles()
                    this.$refs.myVueDropzone4.setOption('url', process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-4")
                }                                                                                                                                                
            },
            scrollToTop() {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }
        },
        computed: {
            sudahUploadPicurl1() {
                console.log('computed sudah pic1');                
                return this.form_data.picurl != "" ? true : false;
            },
            sudahUploadPicurl2() {                
                return this.form_data.picurl2 != "" ? true : false;
            },
            sudahUploadPicurl3() {                                
                return this.form_data.picurl3 != "" ? true : false;
            },
            sudahUploadPicurl4() {                                
                return this.form_data.picurl4 != "" ? true : false;
            },
            isShowJawabanKeDua() {
                return this.showJawabanKeDua;
            },
            isShowJawabanKeTiga() {
                return this.showJawabanKeTiga;
            },
            isShowJawabanKeEmpat() {
                return this.showJawabanKeEmpat;
            },
            isUploadJawaban() {
                return this.currentSoalType === "ESSAY_UPLOAD"
            },
            time: function() {
                //return this.minutes + " : " + this.seconds;
                return this.minutes;
            },
            minutes: function() {
                var min = Math.floor(this.totalTime / 60);
                return min >= 10 ? min : '0' + min;
            },
            seconds: function() {
                var sec = this.totalTime - (this.minutes * 60);
                return sec >= 10 ? sec : '0' + sec;
            }
        },
        mounted() {                        
            this.baseUrlPict = process.env.VUE_APP_BASE_PICT_URL;
            
            this.getTestDetail();
            /*
                1. validasi tes
                    - cek idtestsiswa
                    - cek status test
                    - cek durasi 
                2. get all soal
                3. update jawaban
                4. klik finish update status test to false
                5. go to dashboard
            */
            
            let user = localStorage.getItem("user");
            if (user) {
                this.userDetail = helper.getUserObject(user);

                console.log("USER", this.userDetail);
            }
            console.log("isUploadJawaban", this.isUploadJawaban)
            //this.getSiswaKelas();
            this.singledropzoneOptions = {
                url: process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-1",
                thumbnailWidth: 600,
                autoProcessQueue: true,
                acceptedFiles: 'image/*',
                maxFiles:1,
                maxFilesize: 10,
                resizeWidth: 1600,
                addRemoveLinks: false,
                dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Seret dan lepas file disini atau tekan klik untuk upload jawaban.</h6><span>(file dalam format jpg<strong>maksimum 10 MB</strong>)</span>"
            }
            this.singledropzoneOptions2 = {
                url: process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-2",
                thumbnailWidth: 600,
                autoProcessQueue: true,
                acceptedFiles: 'image/*',
                maxFiles:1,
                maxFilesize: 10,
                resizeWidth: 1600,
                addRemoveLinks: false,
                dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Seret dan lepas file disini atau tekan klik untuk upload jawaban.</h6><span>(file dalam format jpg<strong>maksimum 10 MB</strong>)</span>"
            }
            this.singledropzoneOptions3 = {
                url: process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-3",
                thumbnailWidth: 600,
                autoProcessQueue: true,
                acceptedFiles: 'image/*',
                maxFiles:1,
                maxFilesize: 10,
                resizeWidth: 1600,
                addRemoveLinks: false,
                dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Seret dan lepas file disini atau tekan klik untuk upload jawaban.</h6><span>(file dalam format jpg<strong>maksimum 10 MB</strong>)</span>"
            }
            this.singledropzoneOptions4 = {
                url: process.env.VUE_APP_BASE_SERVER_UPLOAD_URL+'?fname=file-' + this.soalke + "-" + this.userDetail.idtenant + "-" + this.$route.params.idtest + '-' + this.userDetail.iduser + "-4",
                thumbnailWidth: 600,
                autoProcessQueue: true,
                acceptedFiles: 'image/*',
                maxFiles:1,
                maxFilesize: 10,
                resizeWidth: 1600,
                addRemoveLinks: false,
                dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Seret dan lepas file disini atau tekan klik untuk upload jawaban.</h6><span>(file dalam format jpg<strong>maksimum 10 MB</strong>)</span>"
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        }        
    }
</script>
<style scoped>

div >>> img {
    max-width: 100%;
    height: auto;
}

div >>> p {
    margin-bottom:0;
    margin-top: 0;
}

ul.pagination li.finished {  
  display: inline-block;
  background-color:blue;   
}

object, iframe {
  border: 3px solid #cecece;
  background: #e9e9e9;
  width: 100%;
  height: auto;
  overflow: scroll;
}

.float-pagination {
    display: inline-block;
    width: 240px;
    height: auto;        
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 2;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    -webkit-box-shadow: 0 0 37px rgb(8 21 66 / 10%);
    box-shadow: 0 0 37px rgb(8 21 66 / 10%);
    border-radius: 8px;
    padding: 10px;
    background-color: #fff;
    
    /* only transition on transform properties which are hardware accelerated = way better performances */
	-webkit-transition:-webkit-transform .3s ease;
    -moz-transition:   -moz-transform .3s ease;
    -ms-transition:    -ms-transform .3s ease;
    transition:        transform .3s ease;
  	
}

.float-pagination a {
    text-align: center;
    color: black;
    float: left;
    width: 40px;
    height: 36px;
    padding: 8px 16px;
    margin: 2px;
    text-decoration: none;
    line-height: 40px;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    align-items: center;
}

.float-pagination a.active {
  background-color: #4CAF50;
  color: white;
  border-radius: 5px;
}

.float-pagination a.finished {
  background-color: #306cb9;
  color: white;
  border-radius: 5px;
}

.float-pagination a.hide-pagination {
  background-color:  #a34caf;
  color: white;
  border-radius: 30px;
  width: auto;
}

.float-pagination a:hover:not(.active, .hide-pagination) {
  background-color: #ddd;
  border-radius: 5px;
}

.show-page-list-btn{
      background:green;
      display: block;
      width: auto;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: white;
      font-size: 10px;
      font-weight: bold;
      /*border-radius: 50%;*/
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      /*-webkit-border-radius: 50%;*/
      text-decoration: none;
      transition: ease all 0.3s;
      position: fixed;      
      right: 0;
      top: 50%;
      z-index: 10;
    }
.show-page-list-btn:hover{background: blue}
</style>